import { AxiosPromise } from 'axios';
import {
  AuthorsRes,
	CSVContentReq,
	DownloadNetCDFReq,
	Grid30arcsecResponse,
	MapFilterRes,
} from '@/api/endpoints/map/map.types';
import { http } from '@/api/http.api';
import { convertCamelToSnakeCaseObjectKeys } from '@/utils/utils';
import { MapFiltersReqModel } from '@/models/MapFiltersReq.model';

export function getMapFiltersData(req: MapFiltersReqModel): AxiosPromise<MapFilterRes> {
	const obj = new MapFiltersReqModel(req);
	const params = convertCamelToSnakeCaseObjectKeys(obj as any);
	return http.post('/netcdf/filter', params);
}

export function downloadNetCDFFile({ uuid }: DownloadNetCDFReq): AxiosPromise<ArrayBuffer> {
	return http.get(`/netcdf/${uuid}/download`, {
		responseType: 'arraybuffer',
	});
}

export function getCSVContent({ uuid, lat, lon }: CSVContentReq): AxiosPromise<string> {
	return http.get(`/csv/${uuid}/${lat}/${lon}`);
}

export function downloadCSVContent({ uuid, lat, lon }: CSVContentReq): AxiosPromise<ArrayBuffer> {
	return http.get(`/csv/${uuid}/${lat}/${lon}/download`, {
		responseType: 'arraybuffer',
	});
}

export function getAuthors(): AxiosPromise<AuthorsRes> {
	return http.get('/authors');
}

export function get30arcsecGridData({ uuid, lat, lon }: CSVContentReq): AxiosPromise<Grid30arcsecResponse> {
	return http.get(`/arcsec30/${uuid}/${lat}/${lon}`);
}
